module.exports = __webpack_public_path__ + "img/arrow_down_grey_color.6eae1f14.svg";